import { useState, type ReactNode, type SyntheticEvent } from 'react'

import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  Field,
  Input,
} from '@aeris/ui'

/**
 * Dar ao contato um nome só seu — 01/10.
 *
 * Grava na preferência de quem está logado (`use-contact-names.ts`): o
 * cadastro do cliente, o perfil do WhatsApp e a tela dos outros atendentes
 * continuam como estão. Apagar o campo volta ao nome de sempre.
 */
export const ContactNameDialog = ({
  current,
  original,
  onSave,
  onClose,
}: {
  /** O nome que este atendente já deu, ou nulo. */
  current: string | null
  /** O nome de sempre: o do cadastro, o do perfil ou o número. */
  original: string
  onSave: (name: string) => void
  onClose: () => void
}): ReactNode => {
  const [name, setName] = useState(current ?? '')

  const submit = (event: SyntheticEvent): void => {
    event.preventDefault()
    onSave(name)
    onClose()
  }

  return (
    <Dialog
      open
      onOpenChange={(next) => {
        if (!next) onClose()
      }}
    >
      <DialogContent
        title="Nome do contato para você"
        description="Só você vê este nome. O cadastro do cliente e a tela dos outros atendentes não mudam."
      >
        <form onSubmit={submit} className="flex flex-col gap-3">
          <Field
            label="Como você chama este contato"
            hint={`Em branco, volta a aparecer “${original}”.`}
          >
            {(field) => (
              <Input
                {...field}
                autoFocus
                maxLength={60}
                value={name}
                placeholder={original}
                onChange={(event) => {
                  setName(event.target.value)
                }}
              />
            )}
          </Field>

          <DialogFooter>
            {current === null ? null : (
              <Button
                type="button"
                variant="ghost"
                onClick={() => {
                  onSave('')
                  onClose()
                }}
              >
                Voltar ao nome de sempre
              </Button>
            )}
            <Button type="button" variant="secondary" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" variant="primary">
              Salvar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
